export enum Locale {
    LOCALE_EN = 'en',
    LOCALE_RU = 'ru'
}
